import { api } from './api'

export const PATHS = {
  ALL: {
    path: '*',
    fetchInitialData: api.getPage
  }
}

export const MULT_URL: string = 'https://mult.igra-jeka.ru/'

export const ERRORS_MESSADGES = {
  date: 'Введите дату в формате ДД.ММ.ГГГГ',
  differentPasswords: 'Пароли не совпадают',
  imageType: 'Недопустимый формат файла',
  latAndKir: 'Допускается только латиница и кириллица',
  latKirDig: 'Допускаются латиница, кириллица, заглавные буквы и цифры',
  onlyDig: 'Допускаются только цифры',
  requireField: 'Обязательное поле',
  tooLessSimbols: 'Сликом мало символов',
  tooMuchSimbols: 'Сликом много символов',
  uncorrectEmail: 'Некорректный email',
  uncorrectNumber: 'Неверный формат телефона',
  uncorrectPassword:
    'Допускается латиница и должны содержаться минимум 1 заглавная буква и 1 цифра'
}

export const PHOTOS_COUNT_FORMS = ['фотография', 'фотографии', 'фотографий']

export const STAGE_TYPE = {
  1: 'Набор',
  2: 'II этап',
  3: 'III этап',
  4: 'Финал'
}

export const ACCEPT_FILES_IMAGES = [
  '.jpg',
  '.png',
  '.jpeg',
  'image/jpeg',
  'image/png',
  'image/jpg'
]

export const REQUEST_STATUS = {
  ok: 'ok'
}
export const MIN_MEMBER_COUNT = 50
export const MIDDLE_MEMBER_COUNT = 1000
